
import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CaseStudiesCTA() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-28 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#00989e] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#00b4a6] rounded-full blur-3xl"></div>
      </div>

      <div
        ref={ref}
        className={`relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center transition-all duration-1000 ${
          isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
        }`}
      >
        <span className="inline-block px-4 py-1.5 bg-[#00989e]/20 text-[#00b4a6] text-sm font-medium rounded-full mb-6">
          Ready to Start?
        </span>
        <h2 className="font-['Montserrat'] text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Become Our Next Success Story?
        </h2>
        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
          Let&apos;s discuss how we can help transform your brand&apos;s social media presence 
          and drive real business results.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/#contact"
            className="px-8 py-4 bg-[#00989e] text-white font-semibold rounded-full hover:bg-[#007a7f] transition-colors cursor-pointer whitespace-nowrap"
          >
            Start Your Project
          </Link>
          <Link
            to="/#contact"
            className="px-8 py-4 border-2 border-white text-white font-semibold rounded-full hover:bg-white hover:text-slate-900 transition-colors cursor-pointer whitespace-nowrap"
          >
            Schedule Consultation
          </Link>
        </div>
      </div>
    </section>
  );
}
